/* istanbul ignore file */
import { useMutation } from '@apollo/client';

import boardItemTypes from '@constants/boardItemTypes';
import CreateCustomerBoardMutation from '@graphql/Board/mutations/createCustomerBoard';
import { MyBoardsQuery } from './useMyBoards';

interface ICreateCustomerBoardInput {
  name: string;
  items: {
    sourceBoardId?: number;
    id: number;
    model: boardItemTypes;
  }[];
}

export default function useMutationCreateCustomerBoard() {
  const [
    mutationCreateCustomerBoard,
    {
      loading,
      error,
    },
  ] = useMutation(CreateCustomerBoardMutation, {
    refetchQueries: [{ query: MyBoardsQuery }],
  });

  return [
    (createCustomerBoardInput: ICreateCustomerBoardInput) => mutationCreateCustomerBoard({
      variables: { createCustomerBoardInput },
    }),
    {
      loading,
      error,
    },
  ];
}
